class TsUpsellCard extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  connectedCallback() {
    this.setupFormSubmit();
    this.setupVariantChange();
  }

  setupFormSubmit() {
    const button = this.querySelector('#TSFormSubmit');
    if (button) {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.querySelector('form');
        button.innerHTML = 'Adding';
        button.classList.add('active');
        if (form) {
          const formData = new FormData(form);
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch('/cart/add.js', config)
            .then(response => response.json())
            .then(response => {
              this.cart.renderContents(response);
            })
            .catch(error => console.error('Error:', error));
        }
      });
    }
  }

  setupVariantChange() {
    const selectElements = this.querySelectorAll('select');
    const idInput = this.querySelector('input[name="id"]');
    const variantDataElement = this.querySelector('#ProductVariants');
    if (selectElements.length && idInput && variantDataElement) {
      const variants = JSON.parse(variantDataElement.textContent);
      selectElements.forEach(select => {
        select.addEventListener('change', () => {
          const selectedOptions = Array.from(selectElements).map(sel => sel.value);
          const matchingVariant = variants.find(variant =>
            variant.options.every((opt, index) => opt === selectedOptions[index])
          );
          if (matchingVariant) {
            idInput.value = matchingVariant.id;
          }
        });
      });
    }
  }
}

customElements.define('ts-upsell-card', TsUpsellCard);
